// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Unique code of permission.
// Example: "CreatePermission"

export const permissionCodeMinLength = 1;
export const permissionCodeMaxLength = 20;

export const PermissionCodeSchema = t.refinement(t.string, n => n.length >= permissionCodeMinLength && n.length <= permissionCodeMaxLength, 'PermissionCode');

export type PermissionCode = string;
